import { ViewportHeight, ViewportWidth } from 'utils/measurement';

export const PADDED_WIDTH_CIRCLE = new ViewportWidth(30);
export const PADDED_WIDTH_DOTS = new ViewportWidth(25);
export const PADDED_WIDTH = new ViewportWidth(88.88);
export const PADDED_HEIGHT = new ViewportHeight(13.88);
export const PADDED_OFFSET = new ViewportHeight(18.07);

export const MEASUREMENT_ERROR_MARGIN = 0.09;
